/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_PURCHASE_ORDER,
  PURCHASE_ORDER_PATH,
  READ_PURCHASE_ORDER_LIST,
  CREATE_PURCHASE_ORDER,
  UPDATE_PURCHASE_ORDER,
} from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import PurchaseOrderList from 'domain/finance/purchaseOrder/List';
import PurchaseOrderViewPage from 'domain/finance/purchaseOrder/Show';
import PurchaseOrderCreatePage from 'domain/finance/purchaseOrder/createupdate/Create';
import UpdatePurchaseOrderPage from 'domain/finance/purchaseOrder/createupdate/Update';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const usePurchaseOrderRoute = () => {
  const routers = createRoute({ listRoute: PURCHASE_ORDER_PATH });

  return { ...routers, copyEntityRoute: `${routers.singleEntityRoute}/copy` };
};

const PurchaseOrderRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createPurchaseOrderRoute,
    copyEntityRoute,
    updateRoute,
  } = usePurchaseOrderRoute();

  return (
    <ProtectedRouter basePath={PURCHASE_ORDER_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PURCHASE_ORDER_LIST}>
              <PurchaseOrderList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createPurchaseOrderRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_PURCHASE_ORDER}>
              <PurchaseOrderCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_PURCHASE_ORDER}>
              <PurchaseOrderCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_PURCHASE_ORDER}>
              <UpdatePurchaseOrderPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PURCHASE_ORDER}>
              <PurchaseOrderViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PurchaseOrderRouter.getRouterPath = () => `${PURCHASE_ORDER_PATH}/*`;

export default PurchaseOrderRouter;
